import { Box, DialogTitle, IconButton } from "@mui/material"
import { dialogClose } from "."
import { Close as CloseIcon } from '@mui/icons-material';

interface DialogTitleProp {
    title: any;
    isRevalidate?: boolean
    dialogId?: string;
    isDraggable?: boolean;
    accentColor?: string;
}
const DialogTitleBox = (props: DialogTitleProp) => {
    const { title, dialogId = '', isDraggable = false, accentColor } = props
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: accentColor || '#8ab1ff',
                cursor: !!isDraggable ? 'move' : undefined,
                px: 1,
            }}
            id={`${dialogId}-draggable-title`}
        >
            <DialogTitle
                sx={{
                    color: 'white !important',
                    fontSize: 18,
                    fontWeight: 600,
                    py: 1.5,
                    px: 2,
                }}
            >
                {!!title ? title : ''}
            </DialogTitle>
            <IconButton
                sx={{ mr: 1, color: 'white !important' }}
                onClick={() => {
                    dialogClose(!!dialogId ? dialogId : undefined)
                }}
            >
                <CloseIcon sx={{ fontSize: 22 }} />
            </IconButton>
        </Box >
    )
}

export default DialogTitleBox